import { render, staticRenderFns } from "./model-wgj-save.vue?vue&type=template&id=68f21cb2&scoped=true"
import script from "./model-wgj-save.vue?vue&type=script&lang=js"
export * from "./model-wgj-save.vue?vue&type=script&lang=js"
import style0 from "./model-wgj-save.vue?vue&type=style&index=0&id=68f21cb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f21cb2",
  null
  
)

export default component.exports